// src/pages/me/negotiations/components/NegotiationChatContainer.js
// THIS IS YOUR EXACT WORKING VERSION - DO NOT CHANGE
import React, { useEffect, useRef } from "react";

const NegotiationChatContainer = ({ messages, currentUserId }) => {
  const chatContainerRef = useRef(null);

  useEffect(() => {
    // Scroll to the bottom when messages change
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div ref={chatContainerRef}
     className="chat-container my-6 overflow-y-auto max-h-[400px] min-h-[200px] px-4">
      {messages?.map((msg, index) => {
        const isCurrentUser = msg.sender.id === currentUserId || msg.sender === currentUserId;
        return (
          <div
            key={index}
            className={`relative my-4 ${isCurrentUser ? "text-right" : "text-left"}`}
          >
            <div
              dir={isCurrentUser ? "rtl" : "ltr"}
              className={`w-fit max-w-[25rem] ${isCurrentUser ? "ml-auto" : "mr-auto"}`}
            >
              <p className="text-start font-bold mb-3">{msg.sender.name}</p>
              <div
                className={`py-[10px] px-[15px] text-right rounded-lg ${
                  isCurrentUser
                    ? "text-white bg-primary rounded-l-lg"
                    : "text-[#0D082C] bg-[#F1F7FF] rounded-r-lg"
                }`}
              >
                {msg.content}
              </div>
              <div
                dir="ltr"
                className={`text-sm py-1 ${isCurrentUser ? "text-left" : "text-right"}`}
              >
                {new Date(msg.createdAt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NegotiationChatContainer;